import { render, staticRenderFns } from "./BDTIcon.vue?vue&type=template&id=4732c3c4&scoped=true&"
import script from "./BDTIcon.vue?vue&type=script&lang=js&"
export * from "./BDTIcon.vue?vue&type=script&lang=js&"
import style0 from "./BDTIcon.vue?vue&type=style&index=0&id=4732c3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4732c3c4",
  null
  
)

export default component.exports